//Library Imports
import { Col, Row } from "antd";
import React, { FC, Suspense } from "react";

//Local Imports
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import ExportAnalyticsPopup from "../Shared/ExportAnalyticsPopup";
import CustomChart from "./Components/CustomChart";

const TopAccounts = React.lazy(() => import("./Components/TopAccounts"));
const TopPeople = React.lazy(() => import("./Components/TopPeople"));
const TopContent = React.lazy(() => import("./Components/TopContent"));
const StatsBar = React.lazy(() => import("./Components/StatsBar"));

interface IAnalyticsDashboard {
  page?: string;
  tab?: string;
}

const AnalyticsDashboard: FC<IAnalyticsDashboard> = (props: IAnalyticsDashboard) => {
  const campaignId = getQueryCampaignId();
  const emailId = getQueryEmailId();

  return (
    <>
      <Row>
        <Col span={24} className="py-2 my-1">
          <div className="chart-container">
            <CustomChart
              title={"Engagement overview"}
              boxRightOffset={"1.3%"}
              campaignId={campaignId}
              emailId={emailId}
            />
          </div>
        </Col>
        {/* Suspensfully showing the following component with React.lazy */}
        <Suspense fallback={<></>} children={<StatsBar />} />
      </Row>
      <Row gutter={26} className="mb-5">
        {/* Suspensfully showing the following component with React.lazy */}
        <Suspense fallback={<></>} children={<TopAccounts />} />
        <Suspense fallback={<></>} children={<TopPeople />} />
        <Suspense fallback={<></>} children={<TopContent />} />
      </Row>
      <ExportAnalyticsPopup page={"dashboard"} />
    </>
  );
};

export default AnalyticsDashboard;
